<button mat-icon-button [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger">
    <mat-icon>account_circle</mat-icon>
  </button>

  <mat-menu #userMenu="matMenu" [overlapTrigger]="false" class="toolbar-dropdown-menu user-menu menuProfileContainer">
      <!--<span (mouseleave)="userMenuTrigger.closeMenu()">-->
      <mat-card fxLayout="row" fxLayoutAlign="space-around center" class="user-info p-0" style="flex-direction: column !important;">
          <img src="../../../../assets/img/avatars/profile.png" alt="user-image">
          <!-- <mat-icon>account_circle</mat-icon> -->
          <div fxLayout="column" fxLayoutAlign="center center">
              <h2 style="color: black;" *ngIf="payload?.role_id == '3'">Expert</h2>
              <h2 style="color: black;" *ngIf="payload?.role_id == '4'">Reviewer</h2>
              <h2 style="color: black;" *ngIf="payload?.role_id == '5'">Institute</h2>
              <h3 class="secondary-text-color profileTitle">{{payload?.email}}</h3>
              <!-- <p class="secondary-text-color">Member since May. 2016</p> -->
          </div>
      </mat-card>
      <!-- <mat-divider></mat-divider>
      <a mat-menu-item routerLink="/profile/projects">
          <mat-icon>person</mat-icon>
          <span>Profile</span>
      </a>
      <a mat-menu-item routerLink="/profile/user-info">
          <mat-icon>edit</mat-icon>
          <span>Edit Profile</span>
      </a>
      <a mat-menu-item routerLink="settings">
          <mat-icon>settings</mat-icon>
          <span>Settings</span>
      </a>
      <a mat-menu-item routerLink="/">
          <mat-icon>lock</mat-icon>
          <span>Lock screen</span>
      </a>
      <a mat-menu-item routerLink="help">
          <mat-icon>help</mat-icon>
          <span>Help</span>
      </a>
      <mat-divider></mat-divider>
      <a mat-menu-item routerLink="/login">
          <mat-icon>power_settings_new</mat-icon>
          <span>Log out</span>
      </a> -->
      <!--</span>-->
  </mat-menu>